import { QTopPolicyViolationsCard, QAppVersionsWithMostPolicyViolationsCard } from '@kw/quokka-ui';
import { Box } from '@mui/material';
import { DashboardAnalyticsDateRangeDays, DashboardAnalyticsMetrics } from './dashboardAnalytics';
import { useDashboardNavigation } from './useDashboardNavigation';

type PolicyViolationsProps = {
  dateRangeDays: DashboardAnalyticsDateRangeDays;
  metrics: DashboardAnalyticsMetrics | null | undefined;
};

const platforms = ['android', 'ios'] as const;

export const PolicyViolations = ({ dateRangeDays, metrics }: PolicyViolationsProps) => {
  const { navigateToAppReport } = useDashboardNavigation(dateRangeDays);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gap: '24px',
        '& .MuiPaper-root': { width: '100%' },
      }}
    >
      {/* Row 1 — (separate effort) */}
      {/* Row 2 — (separate effort) */}

      {/* Row 3: Top 10 Policy Violations — Android then iOS */}
      {platforms.map(platform => (
        <Box key={`top-policy-${platform}`} sx={{ gridColumn: 'span 3' }}>
          <QTopPolicyViolationsCard
            platform={platform}
            data={(platform === 'android' ? metrics?.topPolicyViolationsAndroid : metrics?.topPolicyViolationsIos) ?? []}
          />
        </Box>
      ))}

      {/* Row 4: App Versions With Most Policy Violations — Android then iOS */}
      {platforms.map(platform => (
        <Box key={`app-versions-policy-${platform}`} sx={{ gridColumn: 'span 3' }}>
          <QAppVersionsWithMostPolicyViolationsCard
            platform={platform}
            data={
              (platform === 'android'
                ? metrics?.appVersionWithMostPolicyViolationsAndroid
                : metrics?.appVersionWithMostPolicyViolationsIos) ?? []
            }
            onViewReportClick={item => navigateToAppReport(item.analysisId)}
          />
        </Box>
      ))}
    </Box>
  );
};
